import { InjectionToken } from '@angular/core';
import { MyDoctorManagerConstants } from './constants';

export const MY_DOCTOR_MANAGER_CONSTANTS = new InjectionToken<MyDoctorManagerConstants>(
  'Constants provided by My Doctor Manager library'
);